import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import {Helmet} from "react-helmet";
import './App.css';

const services2 = [
 
  {name: 'Apple Music', royalty: 0.005103035, logo : 'https://steamcalc-svg.now.sh/apple-music.svg'},
  {name: 'Spotify', royalty: 0.003589881, logo : 'https://steamcalc-svg.now.sh/spotify.svg'},
  {name: 'YouTube', royalty: 0.001288172, logo : 'https://steamcalc-svg.now.sh/youtube.svg'},
  {name: 'Tidal', royalty: 0.00544, logo : 'https://steamcalc-svg.now.sh/tidal.svg'},
  {name: 'Soundcloud', royalty: 0.001305585, logo : 'https://steamcalc-svg.now.sh/soundcloud.png'},
  {name: 'Soundcloud GO', royalty: 0.01037594, logo : 'https://steamcalc-svg.now.sh/soundcloud.png', color: 'yellow'},
  {name: 'Google Play', royalty: 0.005278658, logo : 'https://steamcalc-svg.now.sh/google-play-music.svg' },
  {name: 'Microsoft Groove', royalty: 0.031113139, logo : 'data:image/png;base64,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', color: 'blue'},
  {name: 'Vevo', royalty: 0.002071429, logo : 'https://steamcalc-svg.now.sh/vevo.png'},
  {name: 'Slacker', royalty: 0.006153846, logo : 'https://steamcalc-svg.now.sh/slacker.jpg'},
  {name: 'Deezer', royalty: 0.00510566, logo : 'https://steamcalc-svg.now.sh/deezer.svg'},
  {name: 'Rhapsody', royalty: 0.004579501, logo : 'https://steamcalc-svg.now.sh/rhap.jpg'}
]

class App extends React.Component {
  constructor(props) {
    super(props)
    
    let services = services2
    let dataFromStorage = localStorage.getItem('stream-calculator')

    if (dataFromStorage) {
      services = JSON.parse(dataFromStorage)
    }
    
    this.state = {
      services,
      period: 1
    }
  }

  componentDidMount() {
    const { services } = this.state
    const { search } = window.location

    try {
      const params = search.slice(1).split('&')

      if (params.length) {
        let copy = services.slice()

        params.forEach(service => {

          const parts = service.split('=')
          const name = parts[0]
          const value = parts[1]

          const index = services.findIndex(service2 => name === service2.name.split(' ')[0].toLowerCase())

          if (index !== -1) {
            copy = [
              ...copy.slice(0, index),
              {...copy[index], isActive: true, value },
              ...copy.slice(index + 1)
            ]
          }
        })

        this.setState({
          services: copy
        })
      }
    } catch (e) {

    }
  }
 
  onChange = (e, i) => {
    e.preventDefault()
    e.stopPropagation()
  
    const { services } = this.state
    let newValue = e.target.value

    newValue = newValue.replace(/,/g, "")

    if (newValue[0] === '0' && newValue[1] !== '0') {
      newValue = newValue.slice(1)
    }

    // if (newValue < 500) {
    //   newValue = 500
    // }
    const newServices = [
      ...services.slice(0, i),
      {...services[i], value: newValue},
      ...services.slice(i + 1)
    ]
  
    this.setState({
      services: newServices
    }, this.updateURL)
    localStorage.setItem('stream-calculator', JSON.stringify(newServices))
  }
  
  onToggle = (newValue, i) => {
    const { services } = this.state
    const newServices = [
      ...services.slice(0, i),
      {...services[i], isActive: newValue, value: services[i].value || 0},
      ...services.slice(i + 1)
    ]
    
    this.setState({
      services: newServices
    }, this.updateURL)
    
    localStorage.setItem('stream-calculator', JSON.stringify(newServices))
  }
  
  toggleOff = name => {
    const { services } = this.state
    const index = services.findIndex(service => service.name === name)
    const newServices = [
      ...services.slice(0, index),
      {...services[index], isActive: false},
      ...services.slice(index + 1)
    ]
    
    this.setState({
      services: newServices
    }, this.updateURL)
    
    localStorage.setItem('stream-calculator', JSON.stringify(newServices))
  }
  
  onPeriodChange = period =>
    this.setState({
       period: this.state.period === period ? 1 : period
    })

  updateURL = () => {
    const { services, period } = this.state
    
    const activeServices = services.filter(service => service.isActive)
    const queryParts = activeServices.map(service => `${service.name.split(' ')[0].toLowerCase()}=${service.value}`)
    const newQuery = queryParts.join('&')


    window.history.pushState(null, null, window.location.href.split('?')[0] + '?' + newQuery)
  }

  renderTotal = () => {
    const { services, period } = this.state
    const selected = services.filter(service => service.isActive && service.value)
    const total = (selected.reduce((acc, service) => acc + (service.value && service.value >= 500 ? service.value : 0) * service.royalty, 0) * period).toFixed(2).toLocaleString(navigator.language, { minimumFractionDigits: 2 })
   

    return (
      <div style={{height: '100%'}}>
         <Helmet>
          <title itemProp="name" lang="en">STREAMS EARN ${total}</title>
          <meta name="description" content="streamcalculator" />
          <meta property="og:title" content={total} />
      </Helmet>
      <div className="total">${total.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
        <div className="prices" style={{height: '50%'}}>
          {selected.map(service => {
            const value = (((service.value || 0)*service.royalty) * period).toFixed(2)
            const height = value / total * 100
            return (
              <div className='price' key={service.name} >
                   {service.name}: {service.value < 500 ? 'too few streams' : `$${value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`} <span className="del" onClick={() => this.toggleOff(service.name)}><img src="https://icon.now.sh/x"/></span>
              </div>
            )
          }

          )}

        </div>
       
     </div>
    )
  }
 
  render() {
    const { services, period } = this.state

    return (
      <div>
     
       
        {/* <h1>Stream Calculator</h1> */}
        <div className="contain" >
        <div style={{display: 'flex'}}>
          <div className="left">
          <div className="info title col-4 ">$treamcalculator</div>
          <div className="info step col-4"><b>Step 1</b> : Select Service. </div>
          <div className="info step col-4"><b>Step 2</b> : Enter Total Streams.</div>
               {services.map((service, i) =>
              <div key={service.name} className={ `${service.name.split(' ')[0].toLowerCase()} ${service.isActive ? 'active' : ''} box`} style={service.isActive ? {} : {opacity: 0.5}} >
          
                <div className="hey" onClick={() => this.onToggle(!service.isActive, i)}><strong>{service.name}</strong>         <br />streams
               <div className="serviceLogo"> <img src={service.logo} /></div>
                </div>
                <input type="tel" placeholder="Enter Stream Amount" value={(service.value || "").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} onChange={e => service.isActive && this.onChange(e, i)} />
                
               
              </div>
            )}
            </div>
            <div className="right">
            {/* <h2>Total</h2>
            <h3>By <span className={period === 7 ? 'active-period' : 'not-active-period'} onClick={() => this.onPeriodChange(7)}>Week</span> <span className={period === 30 ? 'active-period' : 'not-active-period'} onClick={() => this.onPeriodChange(30)}>Month</span></h3> */}
                 <Link className="about" to="/about"><img src="https://icon.now.sh/help_outline" /></Link>
            {this.renderTotal()}
       
          </div>
          </div>
       
        </div>
        
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js